import type { GameState, GameAction } from '../game/types';
import { Icons } from './Icons';
import { Notification } from './Notification';
import { RulesModal } from './RulesModal';

type Props = {
  state: GameState;
  dispatch: React.Dispatch<GameAction>;
  onPlaySfx: (type: 'click') => void;
};

export function IntroScreen({ state, dispatch, onPlaySfx }: Props) {
  const handleCount = (c: number) => {
    onPlaySfx('click');
    dispatch({ type: 'SET_PLAYER_COUNT', count: c });
  };

  return (
    <div className="h-dvh flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden max-h-full w-full max-w-4xl border-4 border-green-200 animate-pop-in relative flex flex-col">
        <Notification message={state.notification} />
        <div className="shrink-0 w-full h-[clamp(7rem,22vh,16rem)] bg-green-100 relative overflow-hidden flex items-center justify-center">
          <img
            src="https://images.unsplash.com/photo-1605000797499-95a51c5269ae?q=80&w=1000&auto=format&fit=crop"
            className="w-full h-full object-cover opacity-90 hover:scale-105 transition-transform duration-700"
            alt=""
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent flex flex-col justify-end p-[clamp(0.75rem,2vh,1.5rem)]">
            <h1 className="text-[clamp(2rem,5vh,3.75rem)] font-black text-white drop-shadow-lg mb-2 leading-tight">
              農夫搶水果 🍎
            </h1>
            <p className="text-white/90 text-[clamp(0.875rem,2vh,1.125rem)] font-bold">
              終極豪華版：倖存者之戰
            </p>
          </div>
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto p-[clamp(1rem,3vh,2rem)] max-w-xl mx-auto w-full space-y-[clamp(0.75rem,2vh,2rem)]">
          <div>
            <label className="block text-gray-700 font-bold text-[clamp(1rem,2.5vh,1.25rem)] mb-[clamp(0.5rem,1.5vh,1rem)] text-center">
              參加人數
            </label>
            <div className="flex justify-center gap-[clamp(0.5rem,1.5vh,1rem)]">
              {[2, 3, 4, 5].map((n) => (
                <button
                  key={n}
                  onClick={() => handleCount(n)}
                  className={`w-[clamp(3rem,6vh,4rem)] h-[clamp(3rem,6vh,4rem)] rounded-2xl text-[clamp(1.25rem,3vh,1.5rem)] font-black shadow-lg transition-all btn-3d ${
                    state.playerCount === n
                      ? 'bg-green-500 text-white scale-110'
                      : 'bg-white text-gray-500 hover:bg-gray-50'
                  }`}
                >
                  {n}
                </button>
              ))}
            </div>
          </div>
          <div className="bg-green-50 p-[clamp(0.75rem,2vh,1.5rem)] rounded-2xl border-2 border-green-100">
            <h3 className="text-center font-bold text-green-700 mb-[clamp(0.5rem,1.5vh,1rem)]">農夫大名</h3>
            <div className="grid grid-cols-2 gap-[clamp(0.5rem,1.5vh,1rem)]">
              {Array.from({ length: state.playerCount }).map((_, i) => (
                <div key={i} className="flex items-center gap-2">
                  <span className="w-6 h-6 rounded-full bg-green-200 text-green-700 flex items-center justify-center text-xs font-bold shrink-0">
                    {i + 1}
                  </span>
                  <input
                    type="text"
                    value={state.playerNames[i] ?? ''}
                    onChange={(e) =>
                      dispatch({ type: 'SET_PLAYER_NAME', index: i, name: e.target.value })
                    }
                    className="w-full p-2 border-2 border-white rounded-lg focus:border-green-400 text-center font-bold text-gray-700 shadow-sm"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="flex gap-[clamp(0.5rem,1.5vh,1rem)]">
            <button
              onClick={() => dispatch({ type: 'SHOW_RULES', show: true })}
              className="flex-1 bg-yellow-400 hover:bg-yellow-500 border-b-4 border-yellow-600 text-yellow-900 font-black py-[clamp(0.75rem,2vh,1rem)] rounded-2xl text-[clamp(1rem,2.5vh,1.25rem)] shadow-xl btn-3d flex items-center justify-center gap-2"
            >
              <Icons.Book /> 規則說明
            </button>
            <button
              onClick={() => {
                onPlaySfx('click');
                dispatch({ type: 'GO_TO_SETUP' });
              }}
              className="flex-[2] bg-gradient-to-r from-green-500 to-emerald-600 border-b-4 border-green-700 text-white font-black py-[clamp(0.75rem,2vh,1rem)] rounded-2xl text-[clamp(1.125rem,3vh,1.5rem)] shadow-xl btn-3d flex items-center justify-center gap-2"
            >
              下一步 <Icons.ArrowRight />
            </button>
          </div>
        </div>
      </div>
      {state.showRules && <RulesModal onClose={() => dispatch({ type: 'SHOW_RULES', show: false })} />}
    </div>
  );
}
